import { i18n } from "@/resources/locales";
import axios from "axios";

export class UsersService {
  async getUserLoged(): Promise<any> {
    return await axios.get(`api/users/me?locale=${i18n.locale}`);
  }
  async getUserById(userId: number): Promise<any> {
    return await axios.get(`/api/space_users/${userId}`);
  }
  async getUserInfoSuperSpace(superSpaceUserId: number): Promise<any> {
    return await axios.get(`/api/super_space_users/${superSpaceUserId}/info`);
  }
  async getSpaceUserLoged(spaceId: number): Promise<any> {
    return await axios.get(`api/space_users/space/${spaceId}/me?locale=${i18n.locale}`);
  }
  async requestSpaceUserTechnicalInfo(
    userId: number,
    spaceId: number
  ): Promise<any> {
    return await axios.get(
      `api/users/${userId}/spaces/${spaceId}/request_technical_info`
    );
  }
  async updateSpaceUserPosition(id: number, data: any): Promise<any> {
    return await axios.put(`api/space_users/${id}/update_position`, data);
  }
  async updateUser(data, id: number): Promise<any> {
    return await axios.put(`api/users/${id}/edit_profile`, data);
  }
  async updateUserWorkInOffice(data, id: number): Promise<any> {
    return await axios.put(`api/users/${id}/change_work_in_office`, data);
  }
  async updateStatusUser(data, id: number): Promise<any> {
    return await axios.put(`api/users/${id}/change_status`, data);
  }
  async updateUserAvatar(id: number, data: any): Promise<any> {
    return await axios.put(`api/users/${id}/change_avatar`, data);
  }
  async updateUserPet(id: number, data: any): Promise<any> {
    return await axios.put(`api/users/${id}/change_pet`, data);
  }
  async uploadUserProfileImage(data): Promise<any> {
    return await axios.post(`api/user_files`, data);
  }
  async sendSpaceUserTechnicalInfo(
    spaceUserId: number,
    data: any
  ): Promise<any> {
    return await axios.post(
      `api/space_users/${spaceUserId}/send_technical_info`,
      {
        technicalInfo: data,
      }
    );
  }
  async activateUser(token: string): Promise<any> {
    return await axios.post(`api/users/invitation/activate_user/${token}`, {});
  }
  async activateGuest(token: string, data): Promise<any> {
    return await axios.post(
      `api/users/invitation/activate_guest/${token}`,
      data
    );
  }
  async sendInvitation(data): Promise<any> {
    return await axios.post(`api/users/invitation/invite_by_target`, data);
  }
  async updateConfiguration(props, id: number): Promise<any> {
    return await axios.put(`api/users/${id}/change_configuration`, props);
  }
  async updateSpaceUserDefaultPosition(id: number): Promise<any> {
    return await axios.put(`api/space_users/${id}/update_default_position`, {});
  }
  async deleteUser(password: any, userId: number): Promise<any> {
    return await axios.delete(`api/users/${userId}`, {
      data: { password: password },
    });
  }
  async connectToSpace(props: number, id: number): Promise<any> {
    return await axios.put(`api/space_users/${id}/connect_to_space`, props);
  }
  async removeImageUser(imageId: number) {
    return await axios.delete(`/api/user_files/${imageId}`);
  }
  async getAssistants(superSpaceId: number) {
    return await axios.get(`/api/ai/super_space/${superSpaceId}/assistants`);
  }
  async getAssistantChats(superSpaceId: number, assistantId: number) {
    return await axios.get(`/api/ai/super_space/${superSpaceId}/assistant/${assistantId}/chats`);
  }
  async createAssistantChat(superSpaceId: number, data: any) {
    return await axios.post(`/api/ai/super_space/${superSpaceId}/chats`, data);
  }
  async getAssistantChatHistory(idChat: number, superSpaceId: number, idMessage: string) {
    if (!idMessage)
      return await axios.get(`/api/ai/super_space/${superSpaceId}/chats/${idChat}/history?limit=20`);
    else
      return await axios.get(`/api/ai/super_space/${superSpaceId}/chats/${idChat}/history?limit=20&after=${idMessage}`);
  }
  async sendAssistantMessage(idChat: number, superSpaceId: number, data: any) {
    const headers = {
      'Content-Type': "application/json",
      'Authorization':
        "Bearer " + localStorage.getItem('token'),
    };
    return await fetch(process.env.VUE_APP_API_BASE + `api/ai/super_space/${superSpaceId}/chats/${idChat}/send_message`, { method: "POST", body: JSON.stringify(data), headers: headers });
  }
  async createAssistantTitle(idChat: number, superSpaceId: number) {
    return await axios.put(`/api/ai/super_space/${superSpaceId}/chats/${idChat}/create_title`, {});
  }
  async getChatsBot(spaceId: number, page: string) {
    return await axios.get(`/api/bot/spaces/${spaceId}/chats?page=${page}&itemsPerPage=30`);
  }
  async getHistoryBot(spaceId: number, idChat: number, page: string) {
    return await axios.get(`/api/bot/spaces/${spaceId}/chats/${idChat}/history?page=${page}&itemsPerPage=30`);
  }
  async createTitleChatBot(spaceId: number, idChat: number) {
    return await axios.put(`/api/bot/spaces/${spaceId}/chats/${idChat}/create_title`, {});
  }
  async createChatBot(spaceId: number) {
    return await axios.post(`/api/bot/spaces/${spaceId}/chats`, {});
  }
  async sendMessageBot(spaceId: number, idChat: number, data) {
    const headers = {
      'Content-Type': "application/json",
      'Authorization':
        "Bearer " + localStorage.getItem('token'),
    };
    return await fetch(process.env.VUE_APP_API_BASE + `api/bot/spaces/${spaceId}/chats/${idChat}/send_message`, { method: "POST", body: JSON.stringify(data), headers: headers });
  }
  async createCurriculum(data: any) {
    return await axios.post(`/api/curriculums`, data);
  }
  async updateCurriculum(id: number, data: any) {
    return await axios.put(`/api/curriculums/${id}`, data);
  }
  async deleteCurriculum(id: number) {
    return await axios.delete(`/api/curriculums/${id}`);
  }
  async sendServerPing(spaceUserId: number) {
    return await axios.post(`/api/space_users/${spaceUserId}/ping`, {});
  }
}
